import httpClient from "./httpClient";

const prefix = "/appointments";

export async function deleteApplication(id: number) {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}
